import { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { articlesApi } from '../../api/articlesApi';
import { settingsApi, articleCategoriesApi } from '../../api/contentApi';
import { PageHero } from '../../components/ui/PageHero';
import { Reveal } from '../../components/ui/Reveal';
import { SkeletonCardGrid } from '../../components/ui/Skeleton';
import { ArticleCard } from '../../components/ui/ArticleCard';
import { CategoryFilter } from '../../components/ui/CategoryFilter';
import { Seo } from '../../components/ui/Seo';

export function Blog() {
  const { data: articles, loading } = useFetch(() => articlesApi.list(), []);
  const { data: settings } = useFetch(() => settingsApi.public(), []);
  const { data: categories } = useFetch(() => articleCategoriesApi.list(), []);
  const [categorieId, setCategorieId] = useState('');

  const articlesFiltres = categorieId
    ? articles?.filter((a) => String(a.categorie_id) === categorieId)
    : articles;

  const heroEyebrow = settings?.['blog.hero_eyebrow'] || 'Blog';
  const heroTitre = settings?.['blog.hero_titre'] || 'Actualités & réalisations';
  const heroSousTitre =
    settings?.['blog.hero_sous_titre'] ||
    "Conseils, actualités du réseau, vie de l'agence et exemples concrets d'interventions.";

  return (
    <>
      <Seo
        title="Actualités & réalisations — AXEO Services Cergy"
        description="Conseils, actualités et exemples concrets d'interventions d'AXEO Services à Cergy, Pontoise et dans toute la Communauté d'Agglomération de Cergy-Pontoise."
        path="/blog"
      />

      <PageHero
        eyebrow={heroEyebrow}
        title={heroTitre}
        subtitle={heroSousTitre}
        imageUrl={settings?.['blog.hero_image_url']}
      />

      <section className="section">
        <div className="container">
          {categories?.length > 0 && (
            <Reveal as="div" className="section__header offers-header">
              <CategoryFilter categories={categories} value={categorieId} onChange={setCategorieId} />
            </Reveal>
          )}

          {loading && <SkeletonCardGrid />}

          {!loading && !articlesFiltres?.length && <p>Aucun article publié pour le moment.</p>}

          {!loading && articlesFiltres?.length > 0 && (
            <div className="section__grid section__grid--3">
              {articlesFiltres.map((article, i) => (
                <Reveal key={article.id} delay={i * 60}>
                  <ArticleCard article={article} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
